import {
   AscSortIcon,
   CommentsIcon,
   DescSortIcon,
   DownArrow,
   DummyImage,
   EditIcon,
   FilterClearIcon,
   LikeIcon,
   ShortIcon,
   UpArrowIcon
} from 'assets'
import { DropDown } from 'components'
import { emotionIcon } from 'constant/const'
import dayjs from 'dayjs'
import { useOutsideClick } from 'Hooks'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
   getPostCommentListAction,
   loadMoreInstCommentsAction
} from 'store/action/instagramDashboard'
import { getCommentListAction, loadMoreCommentsAction } from 'store/action/videoReducer'
import { formatNumber } from 'utils/formatNumber'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import { removeUtcFormate } from 'utils/removeUtcFormate'
import InCommentsEditModal from './InCommentsEditModal'
// import CommentsEditModal from './CommentsEditModal'

const sentimentConstOpt = [
   {
      label: 'All',
      value: 'All'
   },
   {
      label: 'Positive',
      value: 'positive'
   },
   {
      label: 'Negative',
      value: 'negative'
   },
   {
      label: 'Neutral',
      value: 'neutral'
   }
]

const sortTypeConstOpt = [
   {
      label: 'All',
      value: 'All'
   },
   {
      label: 'Comment Likes',
      value: 'comment_likes'
   },
   {
      label: 'Replies Count',
      value: 'replies_count'
   },
   {
      label: 'published At',
      value: 'published_at'
   }
]

function PostComments() {
   const dispatch = useDispatch()

   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const {
      loading,
      postDetails,
      commentList,
      loadingComment,
      isNextCommentPage,
      loadMoreCommentsLoading,
      loadMoreComments
   } = instagramDashboardData

   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const [commentData, setCommentData] = useState(null)
   const param = useParams()
   const [page, setPage] = useState(1)
   const [filterOne, setFilterOne] = useState('')
   const [loadMoreComment, setLoadMoreComment] = useState('Fetch more comments')
   const [selectedSentimentFilter, setSelectedSentimentFilter] = useState('All')
   const [openSentimentFilter, setOpenSentimentFilter] = useState(false)
   const sentimentRef = useOutsideClick(() => setOpenSentimentFilter(false))
   const [sortOpenFilter, setSortOpenFilter] = useState(false)
   const [sortType, setSortType] = useState({ label: 'All', or_type: '' })
   const sortTypeRef = useOutsideClick(() => setSortOpenFilter(false))
   const [selectedEmotionType, setSelectedEmotionType] = useState('All')
   const [openEmotionFiler, setOpenEmotionFiler] = useState(false)
   const emotionRef = useOutsideClick(() => setOpenEmotionFiler(false))

   useEffect(() => {
      if (postDetails) {
         if (commentList && commentList?.length && !loadingComment) {
            if (commentData?.length > 0) {
               setCommentData((prevItems) => {
                  const combinedItems = [...prevItems, ...commentList]
                  // Remove duplicates based on a unique property, assuming `id` is unique
                  const uniqueItems = Array.from(
                     new Map(combinedItems.map((item) => [item.comment_id, item])).values()
                  )
                  return uniqueItems
               })
            } else {
               setCommentData(commentList)
            }
         } else {
            setCommentData([])
         }
      } else {
         setCommentData([])
      }
      return () => {}
   }, [commentList, postDetails])

   const getCommentList = (page_number, s_name, sort_type, e_name) => {
      dispatch(
         getPostCommentListAction({
            post_id: param?.id,
            page: page_number || 1,
            sort_by: sort_type !== 'All' ? sort_type : '',
            sentiment: s_name !== 'All' ? s_name : '',
            emotion: e_name !== 'All' ? e_name?.toLowerCase() : ''
         })
      )
   }

   useEffect(() => {
      if (loadMoreComments) {
         window.scrollTo(0, 0)
         setCommentData([])
         setLoadMoreComment('Fetch more comments')
         getCommentList(1, '', '','')
      }
      return () => {}
   }, [loadMoreComments])

   useEffect(() => {
      if (postDetails?.post_id && !loading && postDetails?.comment_count > 0) {
         getCommentList(1, '', '', '')
      }
      return () => {}
   }, [postDetails?.post_id, postDetails, loading])

   const onLoadMoreData = () => {
      setPage(1 + page)
      getCommentList(1 + page, selectedSentimentFilter, sortType.label, selectedEmotionType)
   }

   const onChangeSentimentFilter = (type) => {
      setSelectedSentimentFilter(type)
      getCommentList(1, type, sortType.label, selectedEmotionType)
      setCommentData([])
      setOpenSentimentFilter(false)
   }

   const onChangeEmotionFilter = (type) => {
      setSelectedEmotionType(type)
      getCommentList(1, selectedSentimentFilter, sortType.label, type)
      setCommentData([])
      setOpenEmotionFiler(false)
   }

   const onChangeSortType = (type, o_type) => {
      setSortType({ label: type, or_type: o_type })
      getCommentList(1, selectedSentimentFilter, type, selectedEmotionType)
      setCommentData([])
      setSortOpenFilter(false)
   }

   const clearFilter = () => {
      setSortType({ label: 'All', or_type: '' })
      setSelectedSentimentFilter('All')
      getCommentList(1, '', '', '')
   }
   return (
      <div className="card comment-section-wrap">
         <div className="comment-section atenya-ai-section">
            <div className="atenya-ai-title-section">
               <div className=" atenya-ai-title-wrap">
                  <h2 className="at-text-dark mb-0">Comments</h2>
                  <p className="at-text-light video-comments">
                     {postDetails?.comment_count || 0} comments posted ·{' '}
                     <span className="video-comments-analysis">
                        {postDetails?.analyzed_comment_count || 0} analyzed{' '}
                     </span>
                  </p>
                  {/* <p className="at-text-light">Here's a quick breakdown of the feedback:</p> */}
               </div>
               <div className="comment-filter-section">
                  <div className="at-dropdown-filer-wrap" ref={sentimentRef}>
                     <div
                        className="at-dropdown-filer"
                        onClick={() => {
                           setOpenSentimentFilter(!openSentimentFilter)
                        }}>
                        <span>Sentiment</span>
                        {openSentimentFilter ? <UpArrowIcon /> : <DownArrow />}
                     </div>
                     {openSentimentFilter && (
                        <ul className="at-list-opt">
                           {sentimentConstOpt &&
                              sentimentConstOpt?.map((item, i) => {
                                 return (
                                    <li
                                       onClick={() => {
                                          onChangeSentimentFilter(item.value)
                                       }}>
                                       <div className="at-list-wrap" key={i}>
                                          <span className="at-opt-name">{item?.label}</span>
                                          <span
                                             className={`at-opt-pin ${
                                                selectedSentimentFilter === item?.value
                                                   ? 'active'
                                                   : ''
                                             }`}>
                                             <span className="w-dot"></span>
                                          </span>
                                       </div>
                                    </li>
                                 )
                              })}
                        </ul>
                     )}
                  </div>

                  <div className="at-dropdown-filer-wrap" ref={emotionRef}>
                     <div
                        className="at-dropdown-filer"
                        onClick={() => {
                           setOpenEmotionFiler(!openEmotionFiler)
                        }}>
                        <span className="text-capitalize">
                           {selectedEmotionType !== 'All' ? selectedEmotionType : 'Emotion'}{' '}
                        </span>
                        {openEmotionFiler ? <UpArrowIcon /> : <DownArrow />}
                     </div>
                     {openEmotionFiler && (
                        <ul className="at-list-opt">
                           <li
                              onClick={() => {
                                 onChangeEmotionFilter('All')
                              }}>
                              <div className="at-list-wrap">
                                 <span className="at-opt-name">All</span>
                                 <span
                                    className={`at-opt-pin ${
                                       selectedEmotionType === 'All' ? 'active' : ''
                                    }`}>
                                    {/* active */}
                                    <span className="w-dot"></span>
                                 </span>
                              </div>
                           </li>
                           {emotionIcon &&
                              [...emotionIcon]
                                 .sort((a, b) =>
                                    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                                 )
                                 .map((item, i) => {
                                    return (
                                       <li
                                          key={i}
                                          onClick={() => {
                                             onChangeEmotionFilter(item.name)
                                          }}>
                                          <div className="at-list-wrap">
                                             <span className="at-opt-name text-capitalize">
                                                {item?.name}
                                             </span>
                                             <span
                                                className={`at-opt-pin ${
                                                   selectedEmotionType === item?.name
                                                      ? 'active'
                                                      : ''
                                                }`}>
                                                <span className="w-dot"></span>
                                             </span>
                                          </div>
                                       </li>
                                    )
                                 })}
                        </ul>
                     )}
                  </div>

                  <DropDown
                     option={[
                        { label: 'Fetch more comments', value: 'Fetch more comments' },
                        { label: '200 Comments', value: '200 Comments' },
                        { label: '500 Comments', value: '500 Comments' },
                        { label: 'All Comments', value: 'All Comments' }
                     ]}
                     value={loadMoreComment}
                     onChangeOpt={(data) => {
                        let count
                        if (data === '200 Comments') {
                           count = 200
                        } else if (data === '500 Comments') {
                           count = 500
                        } else if (data === 'All Comments') {
                           count = 'all'
                        } else {
                           count = ''
                        }
                        setLoadMoreComment(data)
                        if (count) {
                           dispatch(
                              loadMoreInstCommentsAction({
                                 offset: count,
                                 post_id: postDetails?.id
                              })
                           )
                        }
                     }}
                  />
                  <CommentListSortFilter
                     setSortOpenFilter={setSortOpenFilter}
                     sortOpenFilter={sortOpenFilter}
                     onChangeSortType={onChangeSortType}
                     sortType={sortType}
                  />

                  {(sortType.label !== 'All' || selectedSentimentFilter !== 'All') && (
                     <div
                        className="owner-logo-section add-border videos-filter-icon"
                        onClick={clearFilter}
                        title="Clear Filter">
                        <FilterClearIcon />
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className="comment-wrap">
            {!loadMoreCommentsLoading &&
               commentData &&
               commentData?.length > 0 &&
               commentData?.map((item, i) => {
                  return (
                     <div className="mt-3" key={i}>
                        <CommentCard item={item} />
                     </div>
                  )
               })}
            {(loadingComment || loadMoreCommentsLoading) &&
               [...Array(3)].map((_, index) => (
                  <div key={index} className="card comment-card mt-3 p-0">
                     <div className="card_sk">
                        <div className="card__title loading"></div>
                        <div className="card__title loading"></div>
                        <div className="card__title loading"></div>
                     </div>
                  </div>
               ))}
         </div>
         {!loadMoreCommentsLoading && postDetails && isNextCommentPage && (
            <div className="load-more mt-4">
               <div
                  className="atenya-ai-btn"
                  onClick={() => {
                     onLoadMoreData()
                  }}>
                  <span>Load More</span>
               </div>
            </div>
         )}
      </div>
   )
}

export default PostComments

const CommentCard = ({ item }) => {
   const [openEditModal, setOpenEditModal] = useState(false)
   const onCloseModal = () => {
      setOpenEditModal(false)
   }
   return (
      <div className="card comment-card">
         <div className="comment-card-border"></div>
         <div className="comment-details">
            <div className="comment-name-section">
               <div className="name-image-section">
                  <img src={DummyImage} alt="user" />
                  <div className="name-date-wrap">
                     <span>{item?.username || `username${item?.id}`} </span>
                     <div>
                        <span className="at-text-light">
                           {' '}
                           {item?.timestamp
                              ? dayjs(removeUtcFormate(item?.timestamp)).format('D MMMM, YYYY')
                              : ''}
                        </span>{' '}
                        {item?.is_edited && (
                           <>
                              ·<span className="edited-text"> Edited</span>{' '}
                           </>
                        )}
                     </div>
                  </div>
               </div>
               <div className="filter">
                  <div className="comment-icon-wrap">
                     <div className="comment-icon-section">
                        <div className="comment-icon">{getSentimentIcon(item?.sentiment)}</div>
                        <span className="text-capitalize">{item?.sentiment}</span>
                     </div>
                     <div className="comment-icon-section last-section">
                        <div className="comment-icon comment-emotion-icon">
                           {getEmotionIcon(item?.emotion, item?.sentiment)}
                        </div>
                        <span className="text-capitalize">{item?.emotion}</span>
                     </div>
                     <div
                        className="comment-icon-section last-section"
                        onClick={() => setOpenEditModal(true)}>
                        <div className="comment-icon">
                           <EditIcon />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="comment-content">{item?.text}</div>
            <div className="comment-count video-icon mt-3">
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <LikeIcon />
                  </div>
                  <span className=" at-text-light video-counter">
                     {formatNumber(item?.likes_count || 0, 2)}
                  </span>
               </div>
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <CommentsIcon />
                  </div>
                  <span className=" at-text-light video-counter">
                     {' '}
                     {formatNumber(item?.num_replies || 0, 2)}
                  </span>
               </div>
            </div>
         </div>

         {/* Comment modal */}
         {openEditModal && (
            <InCommentsEditModal
               commentOpenModal={openEditModal}
               onClose={onCloseModal}
               item={item}
            />
         )}
      </div>
   )
}

const CommentListSortFilter = ({
   setSortOpenFilter,
   sortOpenFilter,
   onChangeSortType,
   sortType
}) => {
   const sortTypeRef = useOutsideClick(() => setSortOpenFilter(false))

   return (
      <div className="at-dropdown-filer-wrap at-sort" ref={sortTypeRef}>
         <div
            className="owner-logo-section add-border videos-filter-icon"
            onClick={() => {
               setSortOpenFilter(!sortOpenFilter)
            }}
            title="Sort By">
            <ShortIcon />
            {sortType.label !== 'All' && <div className="active-dot"></div>}
         </div>
         {sortOpenFilter && (
            <ul className="at-list-opt mobile-at-list-opt">
               <li
                  onClick={() => {
                     onChangeSortType('All', '')
                  }}>
                  <div className="at-list-wrap">
                     <span className="at-opt-name">All</span>
                     <span className={`at-opt-pin ${sortType.label === 'All' ? 'active' : ''}`}>
                        <span className="w-dot"></span>
                     </span>
                  </div>
               </li>

               <CommentSortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Comment Likes'}
                  value={'likes_count'}
               />
               <CommentSortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Published At'}
                  value={'timestamp'}
               />
            </ul>
         )}
      </div>
   )
}

const CommentSortItemLi = ({ onChangeSortType, sortType, label, value }) => {
   return (
      <li
         onClick={() => {
            if (sortType.or_type === 'asc') {
               onChangeSortType(value, 'desc')
            } else if (sortType.or_type === 'desc') {
               onChangeSortType(`-${value}`, 'asc')
            } else {
               onChangeSortType(value, 'desc')
            }
         }}>
         <div className="at-list-wrap">
            <span className="at-opt-name">{label}</span>
            <div className="sort-dot-icon">
               {sortType?.label === value || sortType.label === `-${value}` ? (
                  sortType.or_type === 'asc' ? (
                     <DescSortIcon />
                  ) : sortType.or_type === 'desc' ? (
                     <AscSortIcon />
                  ) : (
                     <ShortIcon />
                  )
               ) : (
                  <ShortIcon />
               )}

               <span
                  className={`at-opt-pin ${
                     sortType.label === value || sortType.label === `-${value}` ? 'active' : ''
                  }`}>
                  <span className="w-dot"></span>
               </span>
            </div>
         </div>
      </li>
   )
}
